<template>
  <card class="card" title="Editar usuario"><br/>
    <div>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text" label="Usuario" placeholder="Nombre de usuario" v-model="user.username" :class="{
              'is-invalid': submitted && $v.user.username.$error
            }"
            disabled
            >
            </fg-input>
            <div v-if="submitted && $v.user.username.$error" class="invalid-feedback">
              <span v-if="!$v.user.username.required">El usuario es requerido</span>
            </div>
            <div v-if="submitted && $v.user.username.$error" class="invalid-feedback">
              <span v-if="!$v.user.username.isUniqueUser">El nombre de usuario ya esta registrado</span>
            </div>
          </div>
          <div class="col-md-6">
            <fg-input type="password" label="Contraseña" placeholder="Contraseña" v-model="user.password"
              pattern="(?=.*\d)(?=.*[a-záéíóúüñ]).*[A-ZÁÉÍÓÚÜÑ].*"
              title="Debe tener al menos una mayúscula, una minúscula y un dígito" :class="{
                'is-invalid': submitted && $v.user.password.$error
              }">
            </fg-input>
            <div v-if="submitted && $v.user.password.$error" class="invalid-feedback">
              <span v-if="!$v.user.password.required">
                Requerido
              </span>
              <span v-if="!$v.user.password.minLength">
                <li>8 caracteres necesarios</li>
              </span>
              <span v-if="!$v.user.password.valid1">
                <li>Al menos una mayúscula</li>
              </span>
              <span v-if="!$v.user.password.valid2">
                <li>Al menos una minúscula</li>
              </span>
              <span v-if="!$v.user.password.valid3">
                <li>Al menos un número</li>
              </span>
              <span v-if="!$v.user.password.valid4">
                <li>Al menos un caractér especial</li>
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Nombre"
              placeholder="Nombre completo"
              v-model="user.name"
              :class="{
               'is-invalid': submitted && $v.user.name.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.user.name.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.user.name.required"
                >El nombre es requerido</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="email"
              label="email"
              id="email"
              name="email"
              placeholder="email"
              v-model="user.email"
              :class="{
                'is-invalid': submitted && $v.user.email.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.user.email.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.user.email.required">
                <li>El email es requerido</li>
              </span>
              <span v-if="!$v.user.email.email">
                <li>Escriba el nombre del dominio</li>
              </span> 
            </div>
          </div>
        </div><br/>

        <div class="row">
          <div class="col-md-12">
            <!-- Estación -->
            <vSelect :options="stations" placeholder="Selecciona una estación" v-model="user.station_id"/>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
              <vSelect 
                  :options="status"
                  placeholder="Selecciona un estatus de usuario"
                  v-model="user.enabled"
                  :class="{
                    'is-invalid': submitted && $v.user.enabled.$error
                  }"
                />
            <div
                v-if="submitted && $v.user.enabled.$error"
                class="invalid-feedback"
              >
              <span v-if="!$v.user.enabled.required"
                >El estatus es requerido</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
              <vSelect 
                  :options="roles"
                  placeholder="Selecciona un rol"
                  v-model="user.rol"
                  :class="{
                    'is-invalid': submitted && $v.user.rol.$error
                  }"
                />
            <div
                v-if="submitted && $v.user.rol.$error"
                class="invalid-feedback"
              >
              <span v-if="!$v.user.rol.required"
                >El rol es requerido</span
              >
            </div>
          </div>
        </div>

        <div><br/>
          <p-button 
            type="info" 
            @click.native.prevent="handleSubmit"
            style="margin-right: 10px;"
            >
            Enviar
          </p-button>
          <p-button type="danger" @click.native.prevent="handleCancel">
            Cancelar
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import usersService from '../../services/usersService';
import "vue-select/dist/vue-select.css";
import state from "../../store/state"
import vSelect from "vue-select";
import store from "../../store";
import swal from 'sweetalert';
export default {
  components:{
    vSelect
  },
  data() {
    return {
      stations: [],
      roles: [
        { label: 'Administrador', value: 'ADMIN' },
        { label: 'Estación', value: 'STATION' },
        { label: 'Soporte', value: 'SUPPORT' }
      ],
      status: ["Activo", "Cuenta Bloqueada"],
      user: {
        station_id: "",
        username: "",
        account_locked: 0,
        name: "",
        password: "",
        enabled: "Activo",
        email: "",
        rol: ""
      },
      id: "",
      submitted: false
    };
  },
  beforeCreate() {
    store.dispatch('actionGetStations');
  },
  async mounted () {
    this.stations = []
    if(
      localStorage.getItem('stationsJSON') &&
      JSON.parse(localStorage.getItem('stationsJSON')).length > 0
    ) {
        this.stations = localStorage.getItem('stationsJSON') 
          ? JSON.parse(localStorage.getItem('stationsJSON')) : []
    } else {
      setTimeout(() => {
        this.stations = state.stations.select
      }, 2000)
    }
    const id = this.$route.params.id;
    await usersService.getByID(id).then(r => {
      this.user.station_id = this.stations.find(st => Number(st.station) === Number(r.data.data.estacion.idEstacion[0]));
      this.user.username = r.data.data.username;
      this.user.name = r.data.data.firstName;
      this.id = r.data.data.id;
      this.user.password = '';
      if (r.data.data.enabled === true) this.user.enabled = 'Activo'
      if (r.data.data.enabled === false) this.user.enabled = 'Cuenta Bloqueada'
      this.user.email = r.data.data.email
      this.user.rol = r.data.data.roles[0] === 'STATION' ? 
        { label: 'Estación', value: 'STATION' } :
        r.data.data.roles[0] === 'ADMIN' ? 
        { label: 'Administrador', value: 'ADMIN' } : 
        { label: 'Soporte', value: 'SUPPORT' }
    })
  },
  validations: {
    user: {
      username: {
        required
      },
      name: { required },
      password: {
        required,
        minLength: minLength(8),
        valid1: function (value) {
          const containsUppercase = /[A-Z]/.test(value);
          return containsUppercase;
        },
        valid2: function (value) {
          const containsLowercase = /[a-z]/.test(value);
          return containsLowercase;
        },
        valid3: function (value) {
          const containsNumber = /[0-9]/.test(value);
          return containsNumber;
        },
        valid4: function (value) {
          const containsSpecial = /[#?!@$%^&*-_]/.test(value);
          return containsSpecial;
        },
      },
      email: {
        required,
        email
      },
      enabled: { required },
      rol: { required }
    }
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) 
        return;

      this.updateUser();
    },
    handleCancel() {
      swal({
        title: '¡Aviso!',
        text: 'Se perdera tu progreso actual',
        icon: 'warning',
        buttons: true,
      }).then((result) => {
        if (result) {
          this.$router.push("/usuarios");
        }
      })
    },
    async updateUser () {
     const { rol, station_id, enabled } = this.user
      if(
        rol.value === 'STATION' &&
        !station_id
      ) {
        swal({
          title: '¡Algo salio mal!',
          text: 'Seleeciona una estación',
          icon: 'warning',
          timer: 3000,
          buttons: false
        })
      } else {
        const id = this.$route.params.id;
        const response = await usersService.updateUserKeycloak(id, 
          {
            ...this.user,
                rol: rol.value,
                station_id: station_id ? station_id : {
                    label: '',
                    station: 0
                },
                enabled: enabled === 'Activo' ? 1 : 0
          }
        )
        
        const form = {
          userId: this.id,
          newPassword: this.user.password
        }

        const resp = await usersService.restoreUserPassword(form)
        if (resp.data.data && resp.data.data === "update password sucessfull") {
          state.users.list = [];
          store.dispatch('actionGetUsers');
          swal({
            title: 'Exitoso', 
            text: 'Se actualizo el usuario correctamente',
            icon: 'success',
            timer: 3000,
            buttons: false
          })
          setTimeout(()=> {
            this.$router.push("/usuarios");
          }, 3000)
        } else {
          swal({
            title: '¡Algo salio mal!',
            text: 'El usuario no se actualizo',
            icon: 'warning', 
            timer: 3000, 
            buttons: false
          })
        }
      }
    }
  },
};
</script>
<style></style>
